<template>
  <div>
    <AdminTableOfContentsDrawer
      :value="isShopSettingsNavbarOpen"
      :sections="getVisibleSettings"
      @input="isShopSettingsNavbarOpen = $event"
    />
  </div>
</template>

<script>
import ShopSettings from '@/constants/ShopSettings'
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'

import AdminTableOfContentsDrawer from '@/components/AdminTableOfContentsDrawer'

export default {
  name: 'AdminShopSettingsNavDrawer',
  components: {
    AdminTableOfContentsDrawer,
  },
  data() {
    return {
      settingsByTopic: ShopSettings,
    }
  },
  computed: {
    ...mapFields('admin', ['isShopSettingsNavbarOpen']),
    ...mapGetters('shop', ['getVisibleSettings']),
  },
}
</script>
